import React from 'react';
import Formsy from 'formsy-react';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import Select from '../../form/Select';
import { getHourOptions } from '../../../helpers/hourOptions';
import { daysOfWeek } from '../../../helpers/selectOptions';
import withOnboarding from '../withOnboarding';

class ClientServiceTime extends React.Component {
  state = {
    hourOptions: [],
    serviceTime: '',
    serviceDayOfWeek: null
  };

  render() {
    return (
      <div className="on-boarding__step on-boarding_step--client">
        <Formsy
          className="on-boarding__wrap on-boarding__wrap--service-time form"
          onValidSubmit={this.handleSubmit}
          onInvalidSubmit={this.handleInvalidSubmit}
          onValid={this.handleValid}
          onInvalid={this.handleInvalid}
        >
          <h1 className="on-boarding__h1">
            When would you like your chef to arrive?
          </h1>
          <p className="on-boarding__p">
            Your chef will be in your home for about 4 hours. You can change
            this preference at any time.
          </p>
          <div className="on-boarding__service-time-form">
            <div className="form__row">
              <div className="form__row-item form__row-item--half">
                <Select
                  name="serviceDayOfWeek"
                  placeholder="Day of the Week"
                  value={this.state.serviceDayOfWeek}
                  options={daysOfWeek}
                  onChange={val =>
                    this.handleSelectChange('serviceDayOfWeek', val)
                  }
                  required
                />
              </div>
              <div className="form__row-item form__row-item--half">
                <Select
                  name="serviceTime"
                  placeholder="Chef Arrival Time"
                  value={this.state.serviceTime}
                  options={this.state.hourOptions}
                  onChange={val => this.handleSelectChange('serviceTime', val)}
                  required
                />
              </div>
            </div>
          </div>
          <FormsySimpleInput
            type="hidden"
            name="all_forms_valid"
            value={this.props.actions.isValid('submit')}
            validations="isTrue"
          />
          <input ref={this.props.actions.assignTrigger} type="submit" hidden />
        </Formsy>
      </div>
    );
  }

  handleSelectChange = (name, value = null) => this.setState({ [name]: value });

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const { serviceTime, serviceDayOfWeek } = this.state;
    // update chef
    const updatedClient = {
      client_service_preferences: [
        {
          start_time: serviceTime.value,
          day_of_week: serviceDayOfWeek.value
        }
      ]
    };
    this.props.updateClient(updatedClient);
    this.props.actions.markComplete(this.props.step);
  };

  reset = () => {
    this.props.updateClient({ client_service_preferences: [] });
  };

  initState(prevProps = {}) {
    const state = {};

    if (this.state.hourOptions.length === 0)
      state.hourOptions = getHourOptions(undefined, false, true, true); // passing undefined to avoid import moment.js

    // init client state from props
    if (this.props.client !== prevProps.client) {
      const { client_service_preferences = [] } = this.props.client;
      if (client_service_preferences.length > 0) {
        const hourOptions =
          'hourOptions' in state ? state.hourOptions : this.state.hourOptions;
        state.serviceTime = hourOptions.find(
          opt => opt.value === client_service_preferences[0].start_time
        );
        state.serviceDayOfWeek = daysOfWeek.find(
          opt => opt.value === client_service_preferences[0].day_of_week
        );
      }
    }

    if (state.serviceTime || state.serviceDayOfWeek || state.hourOptions)
      this.setState(state);
  }

  componentWillMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);
    if (reset) this.reset();
    else this.initState();
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }
}

export default withOnboarding(ClientServiceTime);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientServiceTime.js